import React from "react"
import "./Home.css"
import photo from "../../assets/image.png"

const Home = () => {
  const openNewTab = () => {
    var url = 'https://drive.google.com/file/d/1V7Z4ZmOdMmZZ_945r5ZLdBh0Gvkk3Xal/view?usp=sharing';
    var newWindow = window.open(url, '_blank');

    if (newWindow) {
      newWindow.focus();
    }
  };
  return (
    <>
      <section className='home' id='home'>
        <div className='container f_flex top'>
          <div className='left top'>
            <h1>
              Hello, I am <br /><span>Bhumika Vasanta</span>
            </h1>
            <h2>
              <span>
                a Software Developer
              </span>
            </h2>

            <p>I am a highly skilled Software Developer with a passion for crafting visually appealing and user-friendly web
              applications. Strong problem-solving skills. Experience in writing organized and maintainable code. I am a team
              player and display a strong work ethic. Eager to learn any new technologies that come with the job position.</p>
            <button className="btn_shadow top left" onClick={openNewTab}>
              Check Resume
            </button>
          </div>
          <div className='right'>
            <div className='right_img'>
              <img src={photo} alt='My Pic' />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
